/* eslint- disabled */
import Vue from 'vue';
import VuePaginate from 'vue-paginate';
import { VueMaskDirective } from 'v-mask';
// import HighchartsVue from 'highcharts-vue';
import VueApexCharts from 'vue-apexcharts';
import VueTyperPlugin from 'vue-typer';
import { colorUtil } from '@/utils/colorUtils';
import { snackUtil } from '@/utils/snackUtils';
import VueTour from 'vue-tour';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import '@/assets/css/main.css';
import '@/assets/css/processos/processos.css';
import '@/assets/css/flag-icons.css';
import '@/assets/css/animations.css';
import '@/assets/css/icon-font/css/materialdesignicons.min.css';

// Plugins
import '@/plugins/Toast';
import '@/plugins/dialog';
import '@/plugins/virtualscroller';

import BRPrintDocumentFilter from './filters/BRPrintDocumentFilter';
import SiscomexFormatsFilter from './filters/SiscomexFormatsFilter';
import StringFilter from './filters/StringFilter';
import DataFormatFilter from './filters/DataFormatFilter';
import TelefoneBrFilter from './filters/TelefoneBrFilter';
import mascaraNCM from './utils/mascaras/mascaraNCM';
import UniqueObjects from './filters/UniqueObjects';
import FormatCurrency from './filters/formatCurrency';
import siglaUnidadeMedida from './filters/UnidadeMedida';
import FormatMoney from './filters/formatMoney';
import themeMixin from './mixins/themeMixin';

require('vue-tour/dist/vue-tour.css');

Vue.config.productionTip = false;

Vue.use(VueTour);
Vue.use(BRPrintDocumentFilter);
Vue.use(SiscomexFormatsFilter);
Vue.use(StringFilter);
Vue.use(DataFormatFilter);
Vue.use(mascaraNCM);
Vue.use(TelefoneBrFilter);
Vue.use(VuePaginate);
Vue.use(UniqueObjects);
Vue.use(FormatCurrency);
Vue.use(siglaUnidadeMedida);
Vue.use(FormatMoney);
Vue.use(VueApexCharts);
Vue.use(VueTyperPlugin);
Vue.prototype.$colorUtil = colorUtil;
Vue.prototype.$snackUtil = snackUtil;

Vue.directive('mask', VueMaskDirective);

Vue.mixin(themeMixin);

Vue.use(require('vue-moment'));

// Vue.use(HighchartsVue);
Vue.component('ApexChart', VueApexCharts);

new Vue({
  router,
  store,
  vuetify,
  computed: {
    language() {
      return this.$vuetify.lang.current;
    },
    tabName() {
      if (this.$route.name) {
        return `${this.$vuetify.lang.t(`$vuetify.${this.$route.name}`)} - Trinity`;
      }
      return 'Trinity';
    },
  },
  watch: {
    $route() {
      document.title = this.tabName;
    },
    language() {
      document.title = this.tabName;
    },
  },
  created() {
    document.title = this.tabName;
  },
  render: (h) => h(App),
}).$mount('#app');
